"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _useTranslation = _interopRequireDefault(require("../hooks/useTranslation"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var ChangeTariffButton = function ChangeTariffButton() {
  var t = (0, _useTranslation.default)();
  return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    marginTop: 2,
    marginBottom: 2,
    direction: "column"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Button, {
    dataAttributes: {
      'data-testid': 'plan-card-manage-plan-btn'
    },
    text: t('changeTariff'),
    appearance: "secondary",
    width: "full",
    onClick: function onClick() {
      return console.log('change tariff clicked');
    }
  }));
};
var _default = ChangeTariffButton;
exports.default = _default;